import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Grid, Card, Typography, Dialog, IconButton,
  Avatar, Paper, Fade, Stack, CardActionArea, Slide, Chip
} from "@mui/material";
import {
  FileText, Clock, ListChecks, PlusCircle, X,
  Rocket, Zap, BarChart3, ChevronRight, MessageSquare, 
  History, Wallet, LayoutDashboard
} from "lucide-react";

import FormularioAdelanto from "../Finanzas/FormularioAdelanto.jsx";
import FormularioGasto from "../Finanzas/FormularioCajaChica"; 
import FormularioComunicacion from "../Coordinador/AgregarPedido.jsx"; 
import Reporte from "../Coordinador/Reporte"; 
import bannerImg from "./banner.png";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const PALETTE = {
  ice: "#C2EDF0",
  sky: "#99D9DF",
  pearl: "#EEF3F4",
  aqua: "#00C0CA",
  teal: "#008B9C",
  azur: "#28708B",
  dark: "#22404D",
  red: "#F65F4E",
  slate: "#94A3B8"
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DashboardCoordinacion() {
  const [programas, setProgramas] = useState([]);
  const [programaID, setProgramaID] = useState(null);
  const [programaSeleccionado, setProgramaSeleccionado] = useState(null);
  
  const [openAdelanto, setOpenAdelanto] = useState(false);
  const [openGasto, setOpenGasto] = useState(false);
  const [openPedido, setOpenPedido] = useState(false);
  const [openReporte, setOpenReporte] = useState(false);
  
  const [actualizarReporte, setActualizarReporte] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProgramas = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/Usuarios/obtenerProgramasDeUsuario?mail=${localStorage.getItem("email")}`,
          { headers: { "Content-Type": "application/json", apiKey: localStorage.getItem("apiKey") } }
        );
        if (response.ok) {
          const data = await response.json();
          setProgramas(data);
          if (data.length >= 1 && !programaID) {
            setProgramaID(data[0].id);
            setProgramaSeleccionado(data[0]);
          }
        }
      } catch (error) { console.error(error); }
    };
    fetchProgramas();
  }, [programaID]);

  const handleCloseModals = () => {
    setOpenGasto(false);
    setOpenAdelanto(false);
    setOpenPedido(false);
    setOpenReporte(false);
    setActualizarReporte(prev => prev + 1);
  };

  const accionesFijas = [
    // FILA 1: ACCIONES DE CREACIÓN
   
    { label: "Pedido Comunicación", sub: "Crear un nuevo pedido", icon: MessageSquare, color: PALETTE.aqua,onClick: () =>  navigate("/AgregarPedido")},
    { label: "Registrar Gasto", sub: "Caja chica ", icon: Zap, color: PALETTE.red, onClick: () => setOpenGasto(true) },
    { label: "Solicitar Adelanto", sub: "Nuevo adelanto", icon: PlusCircle, color: PALETTE.teal, onClick: () => setOpenAdelanto(true) },
     { label: "TD", sub: "Soluciones digitales", icon: PlusCircle, color: PALETTE.teal,onClick: () => navigate("/dashboard-transformacion-digital") },
    // FILA 2: HISTORIALES Y GESTIÓN

    { label: "Historial Pedidos", sub: "Seguimiento comunicación", icon: History, color: PALETTE.dark, onClick: () => navigate(`/listaPedidosPorPrograma/${programaID}`) },
    { label: "Historial Gastos", sub: "Caja chica del programa", icon: ListChecks, color: PALETTE.azur, onClick: () => navigate(`/listadoGastosPorPrograma/${programaID}`) },
    { label: "Historial Adelantos", sub: "Pagos y transferencias", icon: Clock, color: PALETTE.slate, onClick: () => navigate(`/adelantos/${programaID}`) },
    { label: "Reporte General", sub: "Métricas y presupuesto", icon: BarChart3, color: PALETTE.teal, onClick: () => setOpenReporte(true) },
   
   
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 6 }, minHeight: "100vh", mt: "64px", bgcolor: "#F0F4F7" }}>
      
      {/* BANNER REFINADO */}
      <Paper elevation={0} sx={{ 
        position: 'relative', mb: 6, borderRadius: '40px', overflow: 'hidden', 
        height: { xs: 140, md: 180 }, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)'
      }}>
        <Box component="img" src={bannerImg} alt="Banner" sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <Box sx={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: `linear-gradient(90deg, ${PALETTE.dark} 0%, rgba(34, 64, 77, 0.4) 100%)`,
          display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 4, md: 6 }
        }}>
          <Typography variant="h3" sx={{ color: 'white', fontWeight: 900 }}>Gestión</Typography>
          <Typography variant="h6" sx={{ color: PALETTE.aqua, fontWeight: 700, opacity: 0.9 }}>
            {programaSeleccionado?.nombre || "..." }
          </Typography>
        </Box>
      </Paper>

      {/* SELECTOR DE PROGRAMAS (Estilo Chips) */}
      <Stack direction="row" spacing={1.5} sx={{ mb: 6, overflowX: 'auto', py: 1, px: 1, '&::-webkit-scrollbar': { display: 'none' } }}>
        {programas.map((p) => {
          const isSelected = programaID === p.id;
          return (
            <Chip
              key={p.id}
              avatar={<Avatar src={`data:${p.logoMimeType};base64,${p.logo}`} />}
              label={p.nombre}
              onClick={() => { setProgramaID(p.id); setProgramaSeleccionado(p); }}
              sx={{
                px: 1, py: 2.8, borderRadius: '18px', fontWeight: 800,
                bgcolor: isSelected ? 'white' : 'rgba(255,255,255,0.4)',
                color: isSelected ? PALETTE.dark : PALETTE.slate,
                border: isSelected ? `2px solid ${PALETTE.aqua}` : '2px solid transparent',
                boxShadow: isSelected ? '0 10px 25px rgba(0,0,0,0.05)' : 'none',
                transition: '0.3s',
                '&:hover': { bgcolor: 'white' }
              }}
            />
          );
        })}
      </Stack>

      {/* ACCIONES TIPO CARD MODERNA */}
      {programaID && (
        <Fade in={!!programaID}>
          <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
            <Grid container spacing={3}>
              {accionesFijas.map((acc, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Card
                    elevation={0}
                    onClick={acc.onClick}
                    sx={{
                      p: 0, borderRadius: '32px', bgcolor: 'white',
                      cursor: 'pointer', transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      border: '1px solid rgba(0,0,0,0.02)',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
                      "&:hover": { 
                        transform: "translateY(-8px)", 
                        boxShadow: '0 20px 30px rgba(0,0,0,0.08)',
                        "& .icon-box": { bgcolor: acc.color, color: 'white' },
                        "& .arrow-icon": { transform: 'translateX(4px)', color: acc.color }
                      }
                    }}
                  >
                    <CardActionArea sx={{ p: 3.5, borderRadius: '32px' }}>
                        <Stack direction="row" alignItems="center" spacing={2.5}>
                            <Box 
                                className="icon-box"
                                sx={{ 
                                    width: 54, height: 54, borderRadius: '18px', 
                                    bgcolor: `${acc.color}12`, color: acc.color,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    transition: '0.3s ease'
                                }}
                            >
                                <acc.icon size={26} />
                            </Box>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="body1" sx={{ fontWeight: 900, color: PALETTE.dark, mb: 0.2, fontSize: '1rem' }}>
                                    {acc.label}
                                </Typography>
                                <Typography variant="caption" sx={{ color: PALETTE.slate, fontWeight: 700, fontSize: '0.75rem' }}>
                                    {acc.sub}
                                </Typography>
                            </Box>
                            <ChevronRight className="arrow-icon" size={18} style={{ transition: '0.3s', color: '#D1D5DB' }} />
                        </Stack>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Fade>
      )}

      {/* MODAL DE FORMULARIOS */}
      <Dialog 
        open={openGasto || openAdelanto || openPedido} 
        onClose={handleCloseModals} 
        maxWidth={openPedido ? "md" : "sm"} 
        fullWidth 
        PaperProps={{ sx: { borderRadius: '40px', p: 1 } }}
      >
        <IconButton onClick={handleCloseModals} sx={{ position: "absolute", right: 25, top: 25, zIndex: 10, bgcolor: '#f5f5f5' }}>
          <X size={20} />
        </IconButton>
        <Box sx={{ p: openPedido ? 2 : 1 }}>
          {openAdelanto && <FormularioAdelanto isModal={true} defaultPrograma={programaID} onSuccess={handleCloseModals} />}
          {openGasto && <FormularioGasto isModal={true} defaultPrograma={programaID} onSuccess={handleCloseModals} />}
          {openPedido && (
            <Box sx={{ p: 2 }}>
              <Typography variant="h4" sx={{ fontWeight: 900, mb: 3, color: PALETTE.dark, textAlign: 'center' }}>Nuevo Pedido</Typography>
              <FormularioComunicacion onSuccess={handleCloseModals} />
            </Box>
          )}
        </Box>
      </Dialog>

      {/* REPORTE FULLSCREEN */}
      <Dialog fullScreen open={openReporte} onClose={handleCloseModals} TransitionComponent={Transition}>
        <Box sx={{ bgcolor: '#F9FAFB', minHeight: '100vh' }}>
            <Box sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: 'white', borderBottom: '1px solid #E5E7EB' }}>
                <Typography variant="h5" sx={{ fontWeight: 900 }}>Reporte de Estado</Typography>
                <IconButton onClick={handleCloseModals} sx={{ bgcolor: '#F3F4F6' }}><X /></IconButton>
            </Box>
            <Box sx={{ p: { xs: 2, md: 5 }, maxWidth: '1300px', mx: 'auto' }}>
                <Paper elevation={0} sx={{ p: 4, borderRadius: '40px', border: '1px solid #E5E7EB' }}>
                    <Reporte idPrograma={programaID} actualizar={actualizarReporte} />
                </Paper>
            </Box>
        </Box>
      </Dialog>

    </Box>
  );
}